<template>
  <el-dialog :title="title" :visible.sync="show" width="50%" :append-to-body="true">
    <div style="width: 100%; height: 100%;" v-loading="loading">
      <div class="w100 pl20 pr20 pt20 pb20">
        <el-form label-width="100px" :model="form" :rules="rules" ref="cardForm" class="demo-form-inline">
          <el-form-item label="卡片名称" prop="cardName" style="min-width: 250px;">
            <el-input v-model="form.cardName" placeholder="请输入卡片名称" maxlength="12"></el-input>
          </el-form-item>
          <el-form-item label="卡片代码" prop="cardCode" style="min-width: 250px;">
            <el-input v-model="form.cardCode" placeholder="请输入卡片代码" maxlength="12"></el-input>
          </el-form-item>
          <el-form-item label="备注" style="min-width: 250px;">
            <el-input type="textarea" :rows="2" maxlength="30" v-model="form.remark" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="show = false">取 消</el-button>
        <el-button @click="submitForm('cardForm')" type="primary">保 存</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>

export default {
  name: "addCard",
  props: ["prorData"],
  components: {},
  data() {
    return {
      show: false,
      loading: false,
      title: '',
      form: {
        cardName: '',
        cardCode: '',
        remark: ''
      },
      rules: {
        cardName: [
          { required: true, message: "请输入卡片名称", trigger: "blur" },
          { min: 2, max: 12, message: '长度在 2 到 12 个字符', trigger: 'blur' }
        ],
        cardCode: [
          { required: true, message: "请输入卡片代码", trigger: "blur" },
          { min: 2, max: 12, message: '长度在 2 到 12 个字符', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {},
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    // 显示弹框
    dialogShow() {
      this.title = "新增卡片";
      this.show = true;
      this.loading = true;
      // 清空表单
      this.$nextTick( () => {
        this.$refs['cardForm'].resetFields();
        this.loading = false;
      })
    },
    // 保存卡片
    submitForm () {
      this.$refs.cardForm.validate(valid => {
        if (valid) {
          this.loading = true;
          this.$http
            .post(this.$base.menhuUrl + "/tabCardInfo/save", this.form)
            .then(({ data }) => {
              if (data.resCode == 0) {
                this.$message.success(data.resMsg);
                this.show = false;
                this.$parent.initPage();
              }
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        } 
      })
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
</style>
